import {BaseProps} from '../types'
import { Modal } from 'antd'
import useDisclosure from '../core/hooks/useDisclosure'

type CertificateData = {
  text: string
  link: string | string[]
}

export default function Certificate(props: BaseProps<CertificateData>) {
  const { data } = props
  const {open, handler} = useDisclosure()
  const onClick = () => {
    handler.open()
  }

  const renderImages = () => {
    if (!props.data?.link) return null
    const data = !Array.isArray(props.data.link) ? [props.data.link] : props.data.link

    return data.map((url, index) => (
      <div className={'mb-4'} key={index}>
        <img className={'w-full'} src={url}/>
      </div>
    ))

  }

  return (
    <div>
      <div className="text-dimgray text-center font-bold cursor-pointer" onClick={onClick}>
        { data.text || 'Xem giấy chứng nhận' }
      </div>
      <Modal
        open={open}
        onCancel={handler.close}
        width={'80%'}
        styles={{
          body: {
            height: '80%',
            overflow: 'auto'
          }
        }}
        footer={null}
      >
        { renderImages() }

      </Modal>
    </div>
  )
}